<div class="filter-pan" *ngIf="showFilters">
  <mat-checkbox [(ngModel)]="systemUpdates"
                (ngModelChange)="loadActionHistory(loadingPage, loadSize)"
                class="margin"
                matTooltip="This will includes Creation of system, Movement to machine and back to inventory, relocation of equipment to a different job site, URC creation, status of system">
    <span class="example-margin">
      {{ "System Updates" | translate | async }}
    </span>
  </mat-checkbox>
  <mat-checkbox [(ngModel)]="componentRepairs"
                (ngModelChange)="loadActionHistory(loadingPage, loadSize)"
                class="margin"
                matTooltip="This will includes Repair of Replacement of components">
    <span class="example-margin">
      {{ "Component Repairs" | translate | async }}
    </span>
  </mat-checkbox>
  <mat-checkbox [(ngModel)]="componentMeasurementUpdates"
                (ngModelChange)="loadActionHistory(loadingPage, loadSize)"
                class="margin"
                matTooltip="This will includes Any adjustment to a component measurement including the reading, worn %, comments, images, CMU, DOC etc">
    <span class="example-margin">
      {{ "Component Measurement Updates" | translate | async }}
    </span>
  </mat-checkbox>
</div>
<hr />
<div class="panel__content no-padding">
    <table class="table table--full-width table--striped">
        <thead>
            <tr>
                <th>{{'Action Date' | translate | async}}</th>
                <th>{{'Action Description & Comment' | translate | async}}</th>
                <th>{{'Old Value' | translate | async}}</th>
                <th>{{'New Value' | translate | async}}</th>
                <th>{{'Modified By' | translate | async}}</th>
                <th *ngIf="isInventory">{{'Cost' | translate | async}}</th>
                <th *ngIf="isInventory">{{'Screen' | translate | async}}</th>
            </tr>
        </thead>
        <tbody>
          <tr *ngFor="let audit of auditTrailHistory">
            <td>{{audit.ActionDate | date:'dd/MM/yyyy'}}</td>
            <td>
              <ng-container *ngIf="audit.ScreenLink; else noLink">
                <a [href]="audit.ScreenLink"
                   target="_blank"
                   rel="noopener noreferrer">
                  {{
                     (audit.ActionDescription?.trim() || '') +
                           (audit.Comment?.trim()
                              ? (audit.ActionDescription?.trim() ? ' - ' : '') + audit.Comment.trim()
                              : '')
                  }}
                </a>
              </ng-container>

              <ng-template #noLink>
                {{
                     (audit.ActionDescription?.trim() || '') +
                           (audit.Comment?.trim()
                              ? (audit.ActionDescription?.trim() ? ' - ' : '') + audit.Comment.trim()
                              : '')
                }}
              </ng-template>
            </td>
            <td>
              <ng-container *ngIf="isImage(audit.OldValue); else oldText">
                <img class="inspection-observation-photo cusrsor" [src]="audit.OldValue" (click)="viewInspectionImage(audit.OldValue, audit.ImageId)" />
              </ng-container>
              <ng-template #oldText>
                {{ audit.OldValue }}
              </ng-template>
            </td>
            <td>
              <ng-container *ngIf="isImage(audit.NewValue); else newText">
                <img class="inspection-observation-photo cusrsor" [src]="audit.NewValue" (click)="viewInspectionImage(audit.NewValue, audit.ImageId)" />
              </ng-container>
              <ng-template #newText>
                {{ audit.NewValue }}
              </ng-template>
            </td>
            <td>{{audit.EnteredBy | aesDecrypt}}</td>
            <td *ngIf="isInventory">{{audit.Cost}}</td>
            <td *ngIf="isInventory">{{audit.Screen}}</td>
          </tr>
        </tbody>
    </table>
    <mat-paginator 
        [length]="auditTrailTotalRecords" 
        [pageSize]="loadSize" 
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="pageChanged($event)">
    </mat-paginator>
</div>
